import {
  buildListingWorkspacePayload,
  matchesListingWorkspaceScope,
} from './listingWorkspaceMeta';
import { normalizeWorkspaceMode } from './accountCenterUtils';
import { canViewAllTeamTasks } from './taskHistoryPermissions';

/** 创建工作流模板/任务时写入个人编号或团队编号 */
export function applyWorkflowWorkspaceFields(record, user, authUserId, workspaceScope) {
  if (!record || record.official) return record;
  const fields = buildListingWorkspacePayload(user, authUserId, workspaceScope);
  return {
    ...record,
    ...fields,
    ownerUserId: authUserId ?? record.ownerUserId,
  };
}

function hasWorkflowScopeMeta(record) {
  return !!(
    String(record?.scopeNo || record?.scope_no || '').trim()
    || String(record?.workspaceMode || record?.captureSpace || '').trim()
  );
}

/** 工作流记录（模板/任务）是否属于当前工作区；官方模板始终可见 */
export function matchesWorkflowWorkspaceScope(record, scope) {
  if (!scope || record?.official) return true;
  if (!hasWorkflowScopeMeta(record)) {
    return normalizeWorkspaceMode(scope.workspaceMode) === 'personal';
  }
  return matchesListingWorkspaceScope(record, scope);
}

export function filterWorkflowScopedRecords(records, scope) {
  const list = Array.isArray(records) ? records : [];
  if (!scope) return list;
  return list.filter((item) => matchesWorkflowWorkspaceScope(item, scope));
}

/** 工作流任务是否属于当前登录用户（无 owner 字段的旧本地任务视为可见） */
export function isWorkflowTaskOwnedByCurrentUser(task, authUserId) {
  if (!task) return false;
  if (authUserId == null || authUserId === '') return true;
  const owner = String(
    task.ownerUserId ?? task.ownerId ?? task.createdByUserId ?? '',
  ).trim();
  if (!owner) return true;
  return owner === String(authUserId);
}

/**
 * 任务列表可见性：服务端已按 workspace + self/team_all 隔离；
 * 客户端再做薄过滤（含 team_all 操作人筛选）。
 */
export function filterWorkflowTasksForViewer(records, {
  workspaceScope = null,
  authUserId = null,
  permissionScope = 'self',
  operatorUserId = null,
} = {}) {
  let list = filterWorkflowScopedRecords(records, workspaceScope);
  const mode = normalizeWorkspaceMode(workspaceScope?.workspaceMode);
  const viewAll = mode === 'team' && canViewAllTeamTasks(permissionScope);

  if (!viewAll && authUserId != null && authUserId !== '') {
    list = list.filter((task) => isWorkflowTaskOwnedByCurrentUser(task, authUserId));
  }

  const operator = operatorUserId != null && String(operatorUserId).trim() !== ''
    ? String(operatorUserId).trim()
    : '';
  if (viewAll && operator) {
    list = list.filter((task) => {
      const owner = String(
        task?.ownerUserId ?? task?.ownerId ?? task?.createdByUserId ?? '',
      ).trim();
      return owner === operator;
    });
  }
  return list;
}
